import { createAction, props } from '@ngrx/store';
import { SearchConfig } from '@spartacus/core';
import { AccessSubjectList } from './uig-access-subject.model';

export const getUigAccessSubjectOverview = createAction(
    '[Uig Access Subject] get uig access subject overview',
    props<{ params: SearchConfig }>()
);

export const getUigAccessSubjectOverviewSuccess = createAction(
    '[Uig Access Subject] get uig access subject overview success',
    props<{ uigAccessSubjectOverview: AccessSubjectList }>()
);

export const getUigAccessSubjectOverviewFailure = createAction(
    '[Uig Access Subject] get uig access subject overview failure',
    props<{ error: Error }>()
);
